import React, {FC, useState} from 'react';
import styled from 'styled-components';

import {Handler, HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {CalendarsPanelId} from '../../../../store/panels/panelStateBase';
import {ResizeSeparator, ResizeSeparatorSidesEnum} from '../../../common/resizeSeparator';
import {MeetingTimesData} from './meetingsettings/meetingSettingsPanel';
import {MeetingSettingsPanelContainer} from './meetingsettings/meetingSettingsPanelContainer';

/*
 * Props.
 */

interface MeetingTimesDialogRightPanelProps {
  panelId: CalendarsPanelId;
  onRequestClose: Handler;
  onSelectMeetingTimes: HandlerOf<MeetingTimesData>;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 100%;
`;

const StyledPanelDiv = styled.div`
  grid-column: 2;
  display: grid;
`;

/*
 * Component.
 */

export const MeetingTimesDialogRightPanel: FC<MeetingTimesDialogRightPanelProps> = (props) => {
  const {onRequestClose, onSelectMeetingTimes, panelId} = props;
  const [rightPanelWidth, setRightPanelWidth] = useState<number>(280);

  return (
    <StyledWrapperDiv style={{width: rightPanelWidth}}>
      <ResizeSeparator
        column={1}
        size={rightPanelWidth}
        minSize={270}
        maxSize={800}
        onSizeChange={setRightPanelWidth}
        side={ResizeSeparatorSidesEnum.LEFT}
      />
      <StyledPanelDiv>
        <MeetingSettingsPanelContainer
          onRequestClose={onRequestClose}
          onSelectMeetingTimes={onSelectMeetingTimes}
          panelId={panelId}
        />
      </StyledPanelDiv>
    </StyledWrapperDiv>
  );
};
